<template>
  <div>
    <div class="text-center">
      {{ label }}
    </div>
    <div class="d-flex justify-space-between align-center mt-3">
      <v-btn
        :disabled="disabled || minReached"
        icon
        color="error"
        @click="number--"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-text-field
        v-model="number"
        :disabled="disabled"
        readonly
        type="number"
        color="techBlue"
        outlined
        dense
        hide-details
        hide-spin-buttons
        class="mx-2"
      />
      <v-btn
        :disabled="disabled || maxReached"
        icon
        color="success"
        @click="number++"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "IncrDecrInput",
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    number: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    maxReached: function () {
      if (this.max == null) {
        return false;
      }
      return this.number + 1 > this.max;
    },
    minReached: function () {
      if (this.min == null) {
        return false;
      }
      return this.number - 1 < this.min;
    },
  },
};
</script>
